// client/src/components/EnquiryForm/EnquiryForm.js

import React, { useState } from 'react'; // Import useState to manage form data
import axios from 'axios'; // Import axios to send data
import './EnquiryForm.css';

const EnquiryForm = () => {
  // Create "state" variables to store the user's input
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: 'Film & Web Series Production', // Default value
    message: '',
  });

  // State for our success/error messages
  const [formMessage, setFormMessage] = useState(null);

  // This list should match your "Our Services" component
  const serviceList = [
    'Film & Web Series Production',
    'Acting & Talent Management',
    'Advertising & Brand Promotions',
    'Digital & Social Media Campaigns',
    'Music Video & Short Film Creation',
    'Event Coverage & Cinematography',
    'Other',
  ];

  // A function that updates the state when the user types
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // A function to handle the form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Stop the form from reloading the page
    setFormMessage(null); // Clear any old messages

    // Create the new enquiry object from our state
    const newEnquiry = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      service: formData.service,
      message: formData.message,
    };

    // Send the data to our backend "add" route
     axios.post('https://om-nidhi-backend.onrender.com/enquiries/add', newEnquiry)
      .then((res) => {
        // Success!
        setFormMessage({
          type: 'success',
          text: 'Enquiry submitted successfully!',
        });
        // Clear the form
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: 'Film & Web Series Production',
          message: '',
        });
      })
      .catch((err) => {
        // Error!
        setFormMessage({
          type: 'error',
          text: 'Error submitting form. Please try again.',
        });
        console.error(err);
      });
  };

  // --- This is the only part you need to replace ---

  return (
    <section id="enquiry" className="section enquiry-section">
      <div className="enquiry-container">
        
        {/* --- COLUMN 1: THE TEXT --- */}
        <div className="enquiry-info">
          <h2>Enquire Now</h2>
          <p>
            Have a project in mind or want to collaborate? Fill out the form
            below, and our team will get back to you as soon as possible.
          </p>
        </div>

        {/* --- COLUMN 2: THE FORM --- */}
        <div className="enquiry-form-container">
          <form className="enquiry-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              className="form-input"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone Number"
              className="form-input"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <select
              name="service"
              className="form-select"
              value={formData.service}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                Select a Service
              </option>
              {serviceList.map((service, index) => (
                <option key={index} value={service}>
                  {service}
                </option>
              ))}
            </select>
            <textarea
              name="message"
              placeholder="Your Message (Optional)"
              className="form-textarea"
              value={formData.message}
              onChange={handleChange}
            ></textarea>

            <button type="submit" className="form-button">
              Submit Enquiry
            </button>

            {/* Display the success/error message here */}
            {formMessage && (
              <div
                className={`form-message ${
                  formMessage.type === 'success' ? 'success' : 'error'
                }`}
              >
                {formMessage.text}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default EnquiryForm;